import { TextCell } from "@similarweb/pro-logic-components";

import { NO_DATA_HYPHEN } from "app/pages/sales-intelligence/constants/common";

import { DATA_AUTOMATION_VALUE } from "./const";

const FallbackLocationCell = () => {
    return <TextCell dataAutomation={DATA_AUTOMATION_VALUE}>{NO_DATA_HYPHEN}</TextCell>;
};

export default FallbackLocationCell;
